import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import PiSymbol from "@/components/PiSymbol";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#080808] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <PiSymbol size={44} />
              <div>
                <div className="font-display text-2xl font-bold">
                  Pie Solutions
                </div>
                <div className="text-[10px] uppercase tracking-[0.32em] text-[#39FF14]/80">
                  For Future Factories
                </div>
              </div>
            </div>
            <p className="text-[#9a9a9a] max-w-md text-sm leading-relaxed">
              Tech-Enabled E2E Procurement for 100% Ethical Sourcing meeting
              Customer's Expectation on QCDMS inline with Global Industry
              Benchmark.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {["Mumbai", "Roorkee", "Noida"].map((c) => (
                <span
                  key={c}
                  className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-display text-white/70 border border-white/15 px-3 py-1.5 rounded-full"
                >
                  <MapPin size={12} className="text-[#39FF14]" />
                  {c}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div className="section-label mb-4">Quick Links</div>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Contact", "/contact"],
              ].map(([l, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${l.toLowerCase()}`}
                    className="text-white/75 hover:text-[#39FF14] transition-colors"
                  >
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="section-label mb-4">Partners</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li>IIT Roorkee</li>
              <li>IIM Mumbai</li>
              <li>CIPET</li>
              <li>Indo German Tool Room</li>
              <li>Coir Board, Govt. of India</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} Pie Solutions (π). All rights reserved.
          </div>
          <div className="text-xs uppercase tracking-[0.3em] font-display text-[#39FF14]">
            Incubated at IIM Mumbai
          </div>
        </div>
      </div>
    </footer>
  );
}
